export default "__VITE_ASSET__CVu232Xz__"